// extracted by mini-css-extract-plugin
module.exports = {"extended":"DeliveryDaysText_extended__AnUYR"};